import { ContextType, use } from 'react';
import ImportCandidateModalContext from './import-candidate-modal-context';

const useImportCandidateModal = (): ContextType<typeof ImportCandidateModalContext> => use(ImportCandidateModalContext);

export default useImportCandidateModal;
